import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { APPS } from "../../constants";
import { AccountService } from "../../services/AccountsService";
import WhatsAppBusinessModal from "./WhatsAppBusinessModal";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import SMSModal from "./SMSModal";
import RCSModal from "./RCSModal";
import { AlertService } from "../../services/Alert";
import { useTranslation } from "react-i18next";
import HasAccess from "../../guards/HasAccess";
import { useSession } from "../../hooks/useSession";
import { PROFILES } from "../../constants";
import useRequest from "../../hooks/useRequest";
import Loader from "../../components/Loader";
export default function ChannelsPage() {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    const {call: callChannels, isRequesting} = useRequest();
    const navigate = useNavigate();

    const { session } = useSession();

    const isRoot = session.profile.toLowerCase() === PROFILES.ROOT;

    const [channels, setChannels] = useState([])
    const [modalSettingsWAB, setModalSettingsWAB] = useState(false)
    const [modalSettingsSMS, setModalSettingsSMS] = useState(false)
    const [modalSettingsRCS, setModalSettingsRCS] = useState(false)


    const whatsappStandar = useMemo(() => channels.find(c => c.app.toUpperCase() === APPS.WHATSAPP_STANDAR), [channels])
    const whatsappBusiness = useMemo(() => channels.find(c => c.app.toUpperCase() === APPS.WHATSAPP_BUSINESS), [channels])
    const rcs = useMemo(() => channels.find(c => c.app.toUpperCase() === APPS.RCS), [channels])
    const call = useMemo(() => channels.find(c => c.app.toUpperCase() === APPS.CALL), [channels])
    const sms = useMemo(() => channels.find(c => c.app.toUpperCase() === APPS.SMS), [channels])

    const handleCloseModalWAB = async (refresh) => {
        if (refresh) {
            await getChannels();
        }

        setModalSettingsWAB(false)
    }

    const handleCloseModalSMS = async (refresh) => {
        if (refresh) {
            await getChannels();
        }

        setModalSettingsSMS(false)
    }

    const handleCloseModalRCS = async (refresh) => {
        if (refresh) {
            await getChannels();
        }

        setModalSettingsRCS(false)
    }

    const getChannels = async () => {
        const { data } = await callChannels(() => AccountService.getChannels(account.id));
        setChannels(data)
    }

    const disconnectSMS = async () => {
        const isConfirmed = await AlertService.warning(`${t('platform.channels.warning-label')}`, `${t('platform.channels.text-sms-warning')}`, async () => {
            try {
                await AccountService.disconnectSMS(account.id)
                await getChannels();

                AlertService.toastSuccess(`${t('platform.channels.unlink-success')}`)
            } catch (error) {
                console.error(error);
                AlertService.error(`${t('platform.channels.error-label')}`,`${t('platform.channels.unlink-error')}`)
            }
        });

        // if (isConfirmed) {

        // }
    }

    const disconnectRCS = async () => {
        const isConfirmed = await AlertService.warning(`${t('platform.channels.warning-label')}`, `${t('platform.channels.text-rcs-warning')}`, async () => {
            try {
                await AccountService.disconnectRCS(account.id)
                await getChannels();

                AlertService.toastSuccess(`${t('platform.channels.unlink-success')}`)
            } catch (error) {
                console.error(error);
                AlertService.error(`${t('platform.channels.error-label')}`,`${t('platform.channels.unlink-error')}`)
            }
        });
    }

    const getSupport = () => {
        AlertService.warning(`${t('platform.channels.warning-label')}`,
            (<div>
                <p>{t('platform.channels.text-warning')}</p>
                <a href="mailto:soportewa@voices.com.mx">soportewa@voices.com.mx</a>
            </div>), async () => {
            });
    }
    useEffect(() => {
        getChannels()
    }, [])

    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-400':''},[isRequesting]);
    return (
        <>
            <Header />
            <Aside />
            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("config.platform-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("platform.channels.channels-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark"><i className="bi-collection-fill text-primary nav-icon"></i> {t("platform.channels.channels-title")}</h1>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-lg-4 mb-3 mb-lg-0">
                            <h4>{t("platform.channels.communication-title")}</h4>
                            <p>{t("platform.channels.communication-p")} </p>
                        </div>
                        <div className="col-lg-8">
                            <div className="row mb-5">
                                <div className="col-12">
                                    <div className="card">

                                        <div className={`card-body relative ${heightRequesting}`}>
                                            {
                                                isRequesting ? <Loader/> :
                                            <div className="list-group list-group-lg list-group-flush list-group-no-gutters">

                                                <div className="list-group-item">
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0">
                                                            <img className="avatar avatar-xs" src="/assets/img/channels/whatsapp-icon.png" alt="Image Description" />
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <div className="row align-items-center">
                                                                <div className="col">
                                                                    <div className="d-flex">
                                                                        <h4 className="mb-0 me-2">{t("platform.channels.whatsapp")} </h4>
                                                                        {/* <span className="badge bg-soft-danger  text-danger "><span className="legend-indicator bg-danger"></span>Cuenta sin conexión</span> */}
                                                                    </div>

                                                                    <p className="fs-5 text-body mb-0">{whatsappStandar?.number || ''}</p>
                                                                </div>
                                                                <div className="col-auto">

                                                                    {
                                                                        whatsappStandar ? (
                                                                            <div className="d-flex align-items-center">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn bg-soft-info-alternative btn-sm text-white-dark"
                                                                                    onClick={() => navigate("/channels/link-message", { state: { account, channels, channel: whatsappStandar.app } })}
                                                                                >
                                                                                    <i className="bi-qr-code text-primary me-1"></i> Enlaces de mensajes</button>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="d-flex align-items-center">
                                                                                <span className="badge bg-soft-danger  text-danger  p-2">{t("platform.channels.inactive")}</span>
                                                                            </div>
                                                                        )
                                                                    }

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="list-group-item">
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0">
                                                            <img className="avatar avatar-xs" src="/assets/img/channels/whatsapp-business-icon.png" alt="Image Description" />
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <div className="row align-items-center">
                                                                <div className="col">
                                                                    <div className="">
                                                                        <h4 className="mb-0 me-2">{t("platform.channels.what-business")} </h4>
                                                                        {(!whatsappBusiness?.cm_wab_id && !whatsappBusiness?.meta_waba_id) && <span className="badge bg-soft-danger text-danger mt-2"><span className="legend-indicator bg-danger"></span>{t("platform.channels.inactive")}</span>}
                                                                    </div>

                                                                    <p className="fs-5 text-body mb-0">{whatsappBusiness?.meta_phone_number || whatsappBusiness?.cm_number}</p>

                                                                    <div className="mt-2">
                                                                        {whatsappBusiness?.status && whatsappBusiness?.wa_status === 'GREEN' && <span className="badge  bg-soft-info-alternative text-white-dark"><span className="legend-indicator bg-primary"></span>{t("platform.channels.high-rate")}</span>}
                                                                        {whatsappBusiness?.status && whatsappBusiness?.wa_status === 'YELLOW' && <span className="badge bg-soft-warning text-white-dark"><span className="legend-indicator bg-warning"></span>{t("platform.channels.medium-rate")}</span>}
                                                                        {whatsappBusiness?.status && whatsappBusiness?.wa_status === 'RED' && <span className="badge bg-soft-danger text-danger"><span className="legend-indicator bg-danger"></span>{t("platform.channels.low-rate")}</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="col-auto">

                                                                    {
                                                                        (whatsappBusiness?.cm_wab_id || whatsappBusiness?.meta_waba_id) ? (
                                                                            <div className="btn-group" role="group">

                                                                                <button className="btn bg-soft-info-alternative btn-sm text-white-dark" onClick={() => navigate("/channels/link-message", { state: { account, channels, channel: whatsappBusiness.app } })}>
                                                                                    <i className="bi-qr-code text-primary me-1"></i> {t("platform.channels.messages-text-link")}
                                                                                </button>

                                                                                <div className="btn-group">
                                                                                    <button type="button" className="btn bg-soft-info-alternative btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                                                                                    <div className="dropdown-menu dropdown-menu-end mt-1" >
                                                                                        {/* <button className="dropdown-item" onClick={() => navigate('/channels/templates')}>
                                                                                            {t("platform.channels.messages-text-template")}
                                                                                        </button> */}
                                                                                        {(isRoot) && (
                                                                                            <button className="dropdown-item" onClick={() => setModalSettingsWAB(true)}>
                                                                                                {t("platform.channels.messages-text-config")}
                                                                                            </button>
                                                                                        )
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                {(isRoot) ? (
                                                                                        <button className="btn bg-soft-info-alternative btn-sm" onClick={() => setModalSettingsWAB(true)}>
                                                                                            <i className="bi-gear-fill me-1"></i>  {t("platform.channels.messages-text-config")}
                                                                                        </button>
                                                                                ) : (
                                                                                    <button className="btn bg-soft-info-alternative btn-sm" onClick={() => getSupport()}>
                                                                                        <i className="bi-life-preserver me-1"></i> {t("platform.channels.messages-text-assistance")}
                                                                                    </button>
                                                                                )
                                                                                }
                                                                            </>
                                                                        )
                                                                    }
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="list-group-item">
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0">
                                                            <img className="avatar avatar-xs" src="/assets/img/channels/sms-icon.png" alt="Image Description" />
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <div className="row align-items-center">
                                                                <div className="col">
                                                                    <h4 className="mb-0">SMS </h4>

                                                                    { sms?.sms_user && <p className="fs-5 text-body mb-0">{t("platform.channels.username-sms")}: {sms.sms_user}</p> }

                                                                    {!sms && <span className="badge bg-soft-danger  text-danger  mt-2"><span className="legend-indicator bg-danger"></span>{t("platform.channels.inactive")}</span>}
                                                                    {sms && <span className="badge  bg-soft-info-alternative  text-white-dark  mt-2"><span className="legend-indicator bg-primary"></span>{t("platform.channels.active")}</span>}
                                                                </div>
                                                                <div className="col-auto">

                                                                    {
                                                                        sms ? (
                                                                            <div className="btn-group" role="group">

                                                                                <button className="btn bg-soft-info-alternative btn-sm text-white-dark" onClick={disconnectSMS}>
                                                                                    <i className="bi-envelope-x-fill text-primary me-1"></i> {t("platform.channels.disconnect")}
                                                                                </button>

                                                                                <div className="btn-group">
                                                                                    <button type="button" className="btn bg-soft-info-alternative btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                                                                                    <div className="dropdown-menu dropdown-menu-end mt-1" >
                                                                                        <button className="dropdown-item" onClick={() => setModalSettingsSMS(true)}>
                                                                                            {t("platform.channels.change-pass-user")}
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <button className="btn bg-soft-info-alternative btn-sm" onClick={() => setModalSettingsSMS(true)}>
                                                                                <i className="bi-gear-fill me-1"></i> {t("platform.channels.messages-text-config")}
                                                                            </button>
                                                                        )
                                                                    }

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="list-group-item">
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0">
                                                            <img className="avatar avatar-xs" src="/assets/img/channels/rcs-icon.png" alt="Image Description" />
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <div className="row align-items-center">
                                                                <div className="col">
                                                                    <h4 className="mb-0">{t("platform.channels.rcs")} </h4>
                                                                    {rcs?.rcs_user && <p className="fs-5 text-body mb-0">{t("platform.channels.username-sms")}: {rcs.rcs_user}</p> }
                                                                    {!rcs && <span className="badge bg-soft-danger  text-danger  mt-2"><span className="legend-indicator bg-danger"></span>{t("platform.channels.inactive")}</span>}
                                                                    {rcs && <span className="badge  bg-soft-info-alternative  text-white-dark  mt-2"><span className="legend-indicator bg-primary"></span>{t("platform.channels.active")}</span>}
                                                                </div>
                                                                <div className="col-auto">

                                                                      {
                                                                        rcs ? (
                                                                            <div className="btn-group" role="group">

                                                                                <button className="btn bg-soft-info-alternative btn-sm text-white-dark" onClick={disconnectRCS}>
                                                                                    <i className="bi-envelope-x-fill text-primary me-1"></i> {t("platform.channels.disconnect")}
                                                                                </button>

                                                                                <div className="btn-group">
                                                                                    <button type="button" className="btn bg-soft-info-alternative btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                                                                                    <div className="dropdown-menu dropdown-menu-end mt-1" >
                                                                                        <button type="button" className="dropdown-item"  onClick={() => navigate('/channels/templatesRCS')}>
                                                                                            Plantillas de mensajes
                                                                                        </button>
                                                                                        <button className="dropdown-item" onClick={() => setModalSettingsRCS(true)}>
                                                                                            {t("platform.channels.change-pass-user")}
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <button className="btn bg-soft-info-alternative btn-sm" onClick={() => setModalSettingsRCS(true)}>
                                                                                <i className="bi-gear-fill me-1"></i> {t("platform.channels.messages-text-config")}
                                                                            </button>
                                                                        )
                                                                    }

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<div className="list-group-item">
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0">
                                                            <img className="avatar avatar-xs" src="/assets/img/channels/calls-icon.png" alt="Image Description" />
                                                        </div>
                                                       <div className="flex-grow-1 ms-3">
                                                            <div className="row align-items-center">
                                                                <div className="col">
                                                                    <h4 className="mb-0">{t("platform.channels.calls")} </h4>
                                                                </div>
                                                                <div className="col-auto">
                                                                    {
                                                                        call ? (
                                                                            <div className="d-flex align-items-center">
                                                                                <span className="badge bg-soft-info  text-info  p-2">{t("platform.channels.active")}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="d-flex align-items-center">
                                                                                <span className="badge bg-soft-danger  text-danger  p-2">{t("platform.channels.inactive")}</span>
                                                                            </div>
                                                                        )
                                                                    }

                                                                </div>

                                                            </div>

                                                                </div>
                                                    </div>
                                                </div>
                                                */}


                                            </div>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <Footer showAlertDummy />
            </main>


            <WhatsAppBusinessModal
                show={modalSettingsWAB}
                onRequestClose={(refresh) => handleCloseModalWAB(refresh)}
            />

            <SMSModal
                show={modalSettingsSMS}
                data={sms}
                onRequestClose={(refresh) => handleCloseModalSMS(refresh)}
            />

            <RCSModal
                show={modalSettingsRCS}
                dataRCS={rcs}
                onRequestClose={(refresh) => handleCloseModalRCS(refresh)}
            />

        </>
    )
}